import * as yup from 'yup';
import { CellarStatusType, CellarType, EnergySavingSystemType } from '../types';

export const createCellarDialogSchema = yup.object().shape({
  venueId: yup.string().nullable().default(null).label('Venue Id'),
  name: yup.string().nullable().required().label('Name'),
  status: yup.mixed<CellarStatusType>().oneOf(Object.values(CellarStatusType)).required().label('CellarStatusType'),
  type: yup.mixed<CellarType>().oneOf(Object.values(CellarType)).required().label('Type'),
  description: yup.string().nullable().default(null).label('Description'),
  energySavingSystem: yup
    .array()
    .of(yup.mixed<EnergySavingSystemType>().oneOf(Object.values(EnergySavingSystemType)).required())
    .nullable()
    .label('Energy Saving System'),
  gasCopExpiryDate: yup.string().nullable().default(null).label('Gas COP Expiry Date')
});

export const updateCellarDialogSchema = yup.object().shape({
  venueId: yup.string().nullable().default(null).label('Venue Id'),
  cellarId: yup.string().nullable().default(null).label('Cellar Id'),
  name: yup.string().nullable().required().label('Name'),
  status: yup.mixed<CellarStatusType>().oneOf(Object.values(CellarStatusType)).required().label('CellarStatusType'),
  type: yup.mixed<CellarType>().oneOf(Object.values(CellarType)).required().label('Type'),
  description: yup.string().nullable().default(null).label('Description'),
  energySavingSystem: yup
    .array()
    .of(yup.mixed<EnergySavingSystemType>().oneOf(Object.values(EnergySavingSystemType)).required())
    .nullable()
    .label('Energy Saving System'),
  gasCopExpiryDate: yup.string().nullable().default(null).label('Gas COP Expiry Date')
});
